/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEligibleToCloseRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetEligibleToCloseResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getEligibleToClose = (request: GetEligibleToCloseRequest, options?: CashRequestOptions) => post<GetEligibleToCloseRequest, GetEligibleToCloseResponse>("/2.0/cash/get-eligible-to-close", request, {...options, rejectOnError: true })